var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10A10 10 0 1 0 10 0 10.012 10.012 0 0 0 0 10Zm18.823 0A8.824 8.824 0 1 1 10 1.176 8.833 8.833 0 0 1 18.823 10ZM10.37 6.447a.588.588 0 0 1 .831 0l3.137 3.137a.588.588 0 0 1 0 .832L11.2 13.553a.588.588 0 0 1-.831-.831l2.132-2.134H6.078a.588.588 0 1 1 0-1.176h6.423l-2.132-2.134a.588.588 0 0 1 0-.83Z",
    fill: "currentColor"
  })));
};
export default SvgArrow;